import type { User } from '@/lib/types/core';

export type EffectiveRoles = {
  player: boolean;
  entertainmentAdmin: boolean;
  admin: boolean;
};

type RoleBearingUser = Pick<User, 'roles' | 'is_active'>;

export function getEffectiveRoles(user: RoleBearingUser | null | undefined): EffectiveRoles {
  const appAdmin = user?.roles?.app_admin === true;

  return {
    player: user?.roles?.player === true,
    entertainmentAdmin: appAdmin || user?.roles?.entertainment_admin === true,
    admin: appAdmin,
  };
}

export function canManageUsers(user: RoleBearingUser | null | undefined): boolean {
  return user?.is_active === true && getEffectiveRoles(user).admin;
}

export function canManageEntertainment(user: RoleBearingUser | null | undefined): boolean {
  return user?.is_active === true && getEffectiveRoles(user).entertainmentAdmin;
}

export function isEligibleEntertainmentParticipant(user: RoleBearingUser | null | undefined): boolean {
  if (user?.is_active !== true) return false;

  const roles = getEffectiveRoles(user);
  return roles.player || roles.entertainmentAdmin || roles.admin;
}
